import { repairFinancials, savStatusTone } from '../pos-v2/posV2SavUtils';

export { repairFinancials, formatSavDate } from '../pos-v2/posV2SavUtils';

export function getAllowedStatuses(currentStatus, statuses, isAdmin) {
  const currentIdx = statuses.indexOf(currentStatus);
  if (isAdmin) return statuses.filter((s) => s !== currentStatus);
  if (currentStatus === 'Livré') return [];
  return statuses.filter((s, idx) => {
    if (s === currentStatus) return false;
    if (s === 'Attente Pièces' || s === 'Non Réparable') return true;
    return idx > currentIdx;
  });
}

export function repairStatusBadge(status) {
  return savStatusTone(status);
}

export function fmtEuro(value) {
  return Number(value || 0).toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function countByStatus(devices, statusList) {
  const counts = { enCours: 0, termines: 0, total: devices.length };
  const enCoursSet = new Set(['Reçu', 'En Cours', 'Attente Pièces', 'En attente de dépôt', 'Pièce Arrivée', 'Pièce Arrive']);
  devices.forEach((d) => {
    if (enCoursSet.has(d.status)) counts.enCours += 1;
    if (d.status === 'Terminé' || d.status === 'Livré') counts.termines += 1;
  });
  return counts;
}
